import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';

export class Template extends Model<Schemas['templates'], Models> {}
